import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { IoArrowBackOutline, IoTrashOutline } from 'react-icons/io5';
import labService from '../lab/labService';
import Navbar from './Navbar';
import '../wallet/css/ManageLicences.css';
import '../wallet/css/WalletContent.css';

const UserDetailsAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [targetUser, setTargetUser] = useState(location.state?.user || null);
  const [isLoading, setIsLoading] = useState(!location.state?.user);

  const [licenses, setLicenses] = useState([]);
  const [loadingLicenses, setLoadingLicenses] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const availableOffers = [
    { id: 'one_nano', title: 'One nanoform', sub: 'specific endpoints' },
    { id: 'many_nano', title: 'Many nanoforms', sub: 'specific endpoints' },
    { id: 'one_nano_all', title: 'One nanoform', sub: 'all endpoints' },
    { id: 'substance_all', title: 'One substance', sub: 'all endpoints' },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  useEffect(() => {
    const fetchFreshData = async () => {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      if (!token) return;

      try {
        const userResponse = await labService.getUserDetailsAdmin(id, token);
        setTargetUser({
          id: userResponse.data.id,
          email: userResponse.data.email,
          companyName: userResponse.data.company || '-',
          organizationNumber: userResponse.data.nip_vat || '-',
          isActive: userResponse.data.is_active,
          coins: userResponse.data.coins,
        });

        const licensesResponse = await labService.getUserLicensesAdmin(id, token);
        setLicenses(licensesResponse.data);

      } catch (error) {
        console.error("Błąd ładowania danych:", error);
      } finally {
        setIsLoading(false);
        setLoadingLicenses(false);
      }
    };

    fetchFreshData();
  }, [id]);

  const handleToggleStatus = async () => {
    const token = JSON.parse(localStorage.getItem('user'))?.access;
    try {
      const response = await labService.toggleUserStatus(id, token);
      setTargetUser(prev => ({ ...prev, isActive: response.data.is_active }));
      setShowConfirmModal(false);
    } catch (error) {
      console.error("Błąd zmiany statusu:", error);
    }
  };

  if (isLoading || !targetUser) {
    return (
      <div className='lab-container'>
        <Navbar />
        <div className="manage-licenses-container">
          <div className="loading-container"><div className="spinner"></div></div>
        </div>
      </div>
    );
  }

  const handleToggleLicense = async (lic) => {
    const action = lic.is_active ? 'deactivate' : 'activate';
    if (window.confirm(`Are you sure you want to ${action} this license?`)) {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        const response = await labService.toggleLicenseStatus(lic.id, token);
        setLicenses(prevLicenses =>
          prevLicenses.map(l => l.id === lic.id ? { ...l, is_active: response.data.is_active } : l)
        );
      } catch (error) {
        console.error("Error toggling license:", error);
        alert("Failed to toggle license status.");
      }
    }
  };

  const handleDeleteLicense = async (licenseId) => {
    if (window.confirm("Are you sure you want to permanently DELETE this license? This action cannot be undone.")) {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        await labService.deleteLicense(licenseId, token);
        setLicenses(prevLicenses => prevLicenses.filter(l => l.id !== licenseId));
      } catch (error) {
        console.error("Error deleting license:", error);
        alert("Failed to delete license.");
      }
    }
  };

  const handleAddLicenseClick = () => {
    navigate(`/manage-licences/${id}/add-license`, {
      state: { userEmail: targetUser.email }
    });
  };

  return (
    <div className='lab-container'>

      {showConfirmModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 99999
        }}>
          <div style={{
            backgroundColor: 'white', padding: '30px', borderRadius: '8px',
            maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
          }}>
            <h3 style={{ color: '#1B4480', marginTop: 0 }}>
              {targetUser.isActive ? 'Confirm Blocking' : 'Confirm Unblocking'}
            </h3>
            <p style={{ color: '#444', marginBottom: '25px', lineHeight: '1.5' }}>
              Are you sure you want to <strong>{targetUser.isActive ? 'block' : 'unblock'}</strong> user <br />
              <span style={{ color: 'var(--qsar-green)', fontWeight: 'bold' }}>{targetUser.email}</span>?
              <br />
              {targetUser.isActive && "This user will lose access to all system features."}
            </p>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
              <button
                onClick={handleToggleStatus}
                className={`btn ${targetUser.isActive ? 'btn-danger' : 'btn-success'}`}
              >
                Yes, {targetUser.isActive ? 'Block' : 'Unblock'}
              </button>
              <button
                onClick={() => setShowConfirmModal(false)}
                className="btn btn-neutral"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Navbar />

      <div className="manage-licenses-container" style={{ padding: '40px' }}>

        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <IoArrowBackOutline
              style={{ fontSize: '32px', cursor: 'pointer', color: '#1B4480' }}
              onClick={() => navigate(-1)}
            />
            <h2 className='h2-title' style={{ margin: 0, color: '#1B4480' }}>
              {targetUser.email}
            </h2>
          </div>

          <div style={{ display: 'flex', gap: '15px' }}>
            <button
              onClick={() => setShowConfirmModal(true)}
              className={`btn ${targetUser.isActive ? 'btn-danger' : 'btn-success'}`}
            >
              {targetUser.isActive ? 'Block User' : 'Unblock User'}
            </button>

            <button
              className="btn btn-primary"
              onClick={handleAddLicenseClick}
            >
              Add License
            </button>
          </div>
        </header>

        <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '25px', marginBottom: '30px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
          <h3 style={{ marginTop: 0, color: '#1B4480', marginBottom: '20px' }}>Account Info</h3>

          <p style={{ marginBottom: '12px' }}><strong>Company:</strong> {targetUser.companyName}</p>
          <p style={{ marginBottom: '12px' }}><strong>Organization Number:</strong> {targetUser.organizationNumber}</p>
          {/* <p style={{ marginBottom: '12px' }}><strong>Current Coins:</strong> <span style={{ color: 'var(--qsar-green)', fontWeight: 'bold', fontSize: '18px' }}>{targetUser.coins}</span></p> */}

          <div style={{ display: 'flex', alignItems: 'center', marginTop: '12px' }}>
            <strong style={{ marginRight: '10px' }}>Account Status:</strong>
            <span className={`badge ${targetUser.isActive ? 'badge-green' : 'badge-red'}`}>
              {targetUser.isActive ? 'Active' : 'Blocked'}
            </span>
          </div>
        </div>

        <div style={{ marginTop: '30px' }}>
          <h3 style={{ color: '#1B4480', marginBottom: '20px', fontSize: '1.5rem', fontWeight: '700' }}>Active Licenses</h3>

          {loadingLicenses ? (
            <div className="loading-container"><div className="spinner"></div></div>
          ) : licenses.length === 0 ? (
            <div style={{ backgroundColor: '#fff', border: '1px dashed #cbd5e0', borderRadius: '8px', padding: '30px', textAlign: 'center', color: '#718096' }}>
              This user doesn't have any licenses yet.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {licenses.map((lic) => (
                <div key={lic.id} style={{
                  backgroundColor: '#fff',
                  border: '1px solid #e2e8f0',
                  borderLeft: lic.is_active ? '5px solid #48bb78' : '5px solid #cbd5e0',
                  borderRadius: '8px',
                  padding: '20px 25px',
                  display: 'flex',
                  alignItems: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                }}>

                  <div style={{ width: '35%', flexShrink: 0 }}>
                    <strong style={{ fontSize: '1.15rem', color: '#2d3748' }}>
                      {availableOffers.find(o => o.id === lic.license_type)?.title || lic.license_type}
                    </strong>
                    <div style={{ color: '#718096', fontSize: '0.9rem', marginTop: '4px' }}>
                      {availableOffers.find(o => o.id === lic.license_type)?.sub || ''}
                    </div>
                  </div>

                  <div style={{ width: '40%', display: 'flex', gap: '40px', color: '#4a5568', justifyContent: 'center' }}>
                    <div>
                      <span style={{ color: '#a0aec0', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Purchased</span>
                      <span style={{ fontWeight: '500' }}>{formatDate(lic.created_at)}</span>
                    </div>
                    <div>
                      <span style={{ color: '#a0aec0', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Expiration</span>
                      <span style={{ fontWeight: '500' }}>{formatDate(lic.expires_at)}</span>
                    </div>
                  </div>

                  <div style={{ width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>

                    <IoTrashOutline
                      title="Delete license"
                      className="icon-action-danger"
                      onClick={() => handleDeleteLicense(lic.id)}
                    />

                    <div style={{ width: '100px', textAlign: 'center' }}>
                      <span
                        className={`badge ${lic.is_active ? 'badge-green' : 'badge-red'} clickable-badge`}
                        onClick={() => handleToggleLicense(lic)}
                      >
                        {lic.is_active ? 'Active' : 'Expired'}
                      </span>
                    </div>

                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default UserDetailsAdmin;
